/* Global accordion toggle. One delegated listener handles every .acc-trigger,
   including editor-added ones (no re-init). Dispatches accordion:toggled from
   the .acc so height-dependent consumers (e.g. the FAQ sidebar) can react. */
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.acc-trigger');
    if (!trigger) return;
    var panel = trigger.nextElementSibling; // .acc-body
    if (!panel) return;
    var acc = trigger.closest('.acc');
    var expanded = trigger.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.offsetHeight; // force reflow
      panel.style.maxHeight = '0px';
      panel.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    } else {
      panel.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      trigger.setAttribute('aria-expanded', 'true');
      panel.addEventListener('transitionend', function handler(ev) {
        if (ev.propertyName === 'max-height') {
          panel.style.maxHeight = 'none';
          panel.removeEventListener('transitionend', handler);
        }
      });
    }

    if (acc) {
      acc.dispatchEvent(new CustomEvent('accordion:toggled', {
        bubbles: true,
        detail: { open: !expanded }
      }));
    }
  });
})();
